import React from "react";
import { Outlet } from "react-router-dom";
import Messenger from "../Share/Component/Messenger";
function PageWrap() {
  return (
    <div>
      <Outlet />
      <Messenger />
    </div>
  );
}
export default PageWrap;
